import z from "zod";

/**
 * Triggers the canvas metadata collab server to unload any data it has.
 */
export const unloadEvent = z.object({ type: z.literal("unload") });

/**
 * Triggers the canvas metadata collab server to unload any data it has.
 */
export type UnloadEvent = z.infer<typeof unloadEvent>;
